import ControlCell from './ControlCell';

export default ControlCell;
